export default __webpack_public_path__ + "static/media/thumb-banner2.7027a529.jpg";